import { useLibrary } from '@stores/Library/Library';
import { useLibraryFolder } from '@stores/Library/LibraryFolder';
import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import css from './MediaDragSource.module.scss';
import { startMediaDrag } from './mediaDrag';

/**
 * Lets a grid card be dragged onto a folder. Only draggable while there is somewhere to drop it —
 * a library with no folders has no targets, and there the browser's own image drag stays as it
 * was.
 */
export const MediaDragSource = observer(function MediaDragSource({
  mediaId,
  children,
}: {
  mediaId: string;
  children: ReactNode;
}) {
  const folder = useLibraryFolder();
  const library = useLibrary();
  const enabled = !library.isReadOnly && folder.folders.length > 0;

  return (
    <div
      className={css.dragSource}
      draggable={enabled}
      onDragStart={enabled ? (event) => startMediaDrag(event, mediaId, folder) : undefined}
    >
      {children}
    </div>
  );
});
